import { EventOrderModel } from "@shop/frontend/web/js/models/EventOrderModel";
import { BottomPane } from "@shop/frontend/web/js/components/BottomPane";

import { EventOrderView } from "./EventOrderView";

export class EventOrderBottom extends BottomPane {
	constructor() {
		super();

		this.model = new EventOrderModel();
		this.view = new EventOrderView();

		this.init();
	}

	init() {
		this.pane("reduced", () => this.view.$tickets.hide());

		this.setUpListeners();
	}

	setUpListeners() {
		$(document).on("click", ".js-tickets-remove", e => {
			const sid = $(e.currentTarget).parents(".tickets__item").attr("data-place");
			const uid = $(e.currentTarget).parents(".tickets__item").attr("data-uid");
			const priceId = $(e.currentTarget).parents(".tickets__item").attr("data-price-id");
			this.emitter.emit("event:remove-from-cart", { sid, uid, priceId });
		});

		$(document).on("click", "#js-order-clear", e => this.emitter.emit("event:clear-order"));
	}

	/* event listeners */
	on(action, fn) {
		/** @event EventOrderBottom#event:clear-order */
		if (action === "clear") this.emitter.subscribe("event:clear-order", () => fn());

		/** @event EventOrderBottom#event:remove-from-cart */
		if (action === "remove-ticket")
			this.emitter.subscribe("event:remove-from-cart", ({ sid, uid, priceId }) =>
				fn({
					sid,
					uid,
					priceId,
				})
			);
	}

	/**
	 * Функция для обновления заказа
	 * Если передать id мероприятия то будет сортировать под конкретное мероприятие! т.к в заказе могут быть несколько мероприятий
	 * @param orderData {Object} - Объект заказа полученный из сервера
	 * @param eventId
	 */
	updateOrder(orderData = {}, eventId = null) {
		/* валидируем заказ полученный из сервера */
		if (orderData && orderData.carts) this.model.validateOrderData(orderData, eventId);
		this.view.render(this.model.getOrderData());


		/* Если заказ пустой то скрываем его */
		if (!this.model.carts.length > 0) return this.hide();

		return this.show();
	}

	clearOrder() {
		this.model.initOrder();

		return this.updateOrder();
	}

	removeActiveCarts(carts) {
		this.model.removeActiveCarts(carts);

		return this.updateOrder();
	}

	getOrderCarts() {
		return this.model.carts ? this.model.carts : [];
	}

	getOrderId() {
		return this.model.id ? this.model.id : null;
	}

	enableBtn() {
		this.view.$placesBuy.removeClass("inactive");
	}

	disableBtn() {
		this.view.$placesBuy.addClass("inactive");
	}

	show() {
		this.view.$tickets.show()
		const wasActive = this.$bottom.hasClass("active");
		this.$bottom.addClass("active");
		$('.price-legend__list').removeClass('price-legend_bottom');
		/* Событие показа — только при переходе из скрытого состояния:
		   иначе каждое обновление заказа заново запускает подписчиков
		   панели (доп. услуги) и получаем лишние запросы/мигание */
		if (!wasActive) return this.emitter.emit("event:show-pane");
	}

	hide() {
		this.reduce();
		this.$bottom.removeClass("active");
		$('.price-legend__list').addClass('price-legend_bottom');
		return this.emitter.emit("event:hide-pane");
	}
}
